import { useLocalStorage } from "usehooks-ts";

export { useLocalStorage };

export default useLocalStorage;
